@if (book && type) {
  <div class="book" (click)="goToBook(book.uuid, book.title)" [class.desktop]="(appService.isMobile$ | async) === false">
    <div class="cover" [class.mobile]="appService.isMobile$ | async">
      <img fill [ngSrc]="book | compressedImage" alt="{{ book.title }}" />
    </div>
    <div class="book-title" [class.mobile]="appService.isMobile$ | async">
      <div class="title"> {{ book.title }} </div>
    </div>
  </div>
} @else {
  <div class="book placeholder"></div>
}
